import React, { useEffect } from "react";
import cocoPointing from "public/assets/coco_pointing.svg";
import Image from "next/legacy/image";
import { Button } from "components/atoms/button/button";
import {
  OverlayContainer,
  TooltipContainer,
  TooltipTitle,
  TooltipSubTitle,
  ButtonContainer,
  Arrow,
  CharacterImageWrapper
} from "./bird-tooltip-overlay.styles";

interface BirdTooltipOverlayProps {
  isVisible: boolean;
  onSkip: () => void;
  onCheckNow: () => void;
}

const BirdTooltipOverlay: React.FC<BirdTooltipOverlayProps> = ({
  isVisible,
  onSkip,
  onCheckNow
}) => {
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <OverlayContainer>
      <TooltipContainer>
        <TooltipTitle>Cek kelasmu yang akan datang di sini 🤩</TooltipTitle>
        <TooltipSubTitle>Biar nggak ketinggalan kelas!</TooltipSubTitle>
        <ButtonContainer>
          <Button variant="ghost" onClick={onSkip}>
            Nanti aja
          </Button>
          <Button variant="primary" onClick={onCheckNow}>
            Cari tahu
          </Button>
        </ButtonContainer>

        <Arrow />
      </TooltipContainer>

      <CharacterImageWrapper>
        <Image
          src={cocoPointing}
          alt={"coco pointing"}
          layout="responsive"
          objectFit="fill"
        />
      </CharacterImageWrapper>
    </OverlayContainer>
  );
};

export default BirdTooltipOverlay;
